module.exports = __webpack_public_path__ + "static/media/BELT-BNB.63512cd7.svg";